import * as React from 'react';
import { observer } from 'mobx-react';
import Dropzone = require('react-dropzone');
import { Button, FormControl, FormGroup } from 'react-bootstrap';
import { observable, action, computed } from 'mobx';
import { ApiStore } from '../../../stores/ApiStore';
import { inject, bind } from '../../../utils/decorators';
import { VorgangStore } from '../../../stores/VorgangStore';
import FaIcon from '../../site/FaIcon';
import { IThumbnail, IThumbnailsResponse, IResponse } from '../../../models/ApiTypes';

export interface IFormularElementFotoUploadThumbnailProps {
  vorgangId: string;
  thumbnail: IThumbnail;
}

class FormularElementFotoUploadThumbnail extends React.Component<IFormularElementFotoUploadThumbnailProps, {}> {
  @inject(ApiStore) apiStore: ApiStore;
  render() {
    let { thumbnail, vorgangId } = this.props;
    let downloadUrl = this.apiStore.vorgangDokumentDownloadUrl(vorgangId, thumbnail.eintrag_guid);
    let previewUrl = this.apiStore.vorgangThumbnailPreviewUrl(vorgangId, thumbnail.eintrag_guid);
    return (<a href={downloadUrl} target="_blank"><img src={previewUrl} className="img-thumbnail foto-thumb"/></a>);
  }
}

interface IFormularElementFotoUploadProps {
  vorgangId: string;
  kategorie: string;
  name: string;
  onHandleValidation?: (validationstate: 'success' | 'warning' | 'error' | undefined) => void;
}

/** Komponente für den Upload von Fotos inkl. Thumbnailanzeige als Teil der Formulareingaben */
@observer
export default class FormularElementFotoUpload extends React.Component<IFormularElementFotoUploadProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable dragging: boolean = false;
  @observable acceptedFiles?: File[];
  @observable kategorie?: string;

  @observable thumbnails: IThumbnail[];

  componentDidMount() {
    this.kategorie = this.props.kategorie;
    this.refresh();
  }

  componentWillReceiveProps(nextProps: IFormularElementFotoUploadProps) {
    if (nextProps.kategorie !== this.props.kategorie) {
      this.kategorie = nextProps.kategorie;
    }
  }

  async refresh() {
    let response: IResponse<IThumbnailsResponse>;
    response = await this.apiStore.vorgangThumbnails(this.props.vorgangId);
    if (response && response.ok) {
      this.setThumbnails(response.json);
    }
  }

  @action setThumbnails(thumbnails: IThumbnailsResponse) {
    this.thumbnails = thumbnails;
    if (this.props.onHandleValidation) {
      if (thumbnails.length > 0) {
        this.props.onHandleValidation('success');
      } else {
        this.props.onHandleValidation('error');
      }
    }
  }

  @computed get filesSelected() {
    return ((this.acceptedFiles !== undefined) && this.acceptedFiles.length > 0);
  }

  @bind @action handleFileDrop(accepted: File[]) {
    if (accepted.length > 0) {
      this.acceptedFiles = Array.from(accepted);
    }
    this.handleSetDragging(false);
  }

  @bind @action handleFileDropRejected(rejected: File[]) {
    this.handleClearAcceptedFile();
    this.handleSetDragging(false);
  }

  @bind @action handleClearAcceptedFile() {
    this.acceptedFiles = undefined;
  }

  @action handleSetDragging(dragging: boolean) {
    this.dragging = dragging;
  }

  @bind async handleUpload() {
    if (this.acceptedFiles && this.kategorie) {
      const { vorgangId } = this.props;
      const response = await this.apiStore.vorgangFotoUpload(vorgangId, this.kategorie, this.acceptedFiles);
      if (response.ok) {
        this.handleClearAcceptedFile();
        this.refresh();
      }
    }
  }

  @bind @action handleKategorieChanged(event: React.FormEvent<FormControl>) {
    this.kategorie = (event.target as HTMLInputElement).value;
  }

  render() {
    // tslint:disable-next-line:no-any
    let dropZone: any;

    return (
      <div>
        <Dropzone
          accept=".jpg,.jpeg,.png"
          ref={ref => dropZone = ref}
          multiple={true}
          disableClick={true}
          style={{}}
          className={`upload-dropzone ${this.dragging ? 'upload-dropzone-dragging' : ''}`}
          onDragEnter={() => this.handleSetDragging(true)}
          onDragLeave={() => this.handleSetDragging(false)}
          onDropAccepted={this.handleFileDrop}
          onDropRejected={this.handleFileDropRejected}
        >
          {this.filesSelected ? (
            <div>
              {this.acceptedFiles ?
              <div>
                <h4>{this.acceptedFiles.length} Datei(en) ausgewählt:</h4>
                <div>
                  <ul>{this.acceptedFiles.map((file, index) => <li key={index}>{file.name} ({Math.ceil(10 * file.size / 1024 / 1024) / 10} MB) </li> )}</ul>
                </div>
              </div> : null}
            </div>
          ) : (
            <div>
              <div className="text-center">
                <div style={{fontSize: '4em'}}><FaIcon icon="cloud-upload" /></div>
                <div>
                  Dateien auswählen oder per Drag&Drop auf die Fläche fallen lassen.<br/>
                  Unterstützte Formate: jpg, jpeg, png
                </div>
              </div>
            </div>
          )}
        </Dropzone>

        <div className="text-center">
            {this.filesSelected ? (
              <div>
                <Button onClick={this.handleClearAcceptedFile}>Abbrechen</Button>
                <Button bsStyle="primary" onClick={this.handleUpload} disabled={!this.kategorie}>Ausgewählte Datei hochladen</Button>
              </div>
            ) : (
              <Button onClick={() => dropZone.open()}>Dateien auswählen</Button>
            )}
        </div>

        {/* Anzeige der zum Vorgang hochgeladenen Bilder */}
        <div className="foto-upload-thumblist">
            {!this.thumbnails ? (
              <span>Lade Bilder...</span>
            ) : (this.thumbnails.length === 0) ? (
              <span>Es wurden noch keine Bilder hochgeladen</span>
            ) : <div>Gespeicherte Bilder:<br/>{this.thumbnails.map((thumbnail, index) => <FormularElementFotoUploadThumbnail key={index} vorgangId={this.props.vorgangId} thumbnail={thumbnail}  />)}</div>}
        </div>

        {/* Wert als unsichtbares Feld übermitteln wenn Thumbnails hinterlegt sind, damit die Komponente in die Auswertung auf Vollständigkeit der Eingaben mit aufgenommen werden kann */}
        {(this.thumbnails && this.thumbnails.length > 0) &&
          <FormGroup>
            <FormControl type="hidden" name={this.props.name} value={this.thumbnails.length}/>
          </FormGroup>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/formularelemente/FormularElementFotoUpload.tsx